export const OrganisationTabOption = [
    {
        label: "Site Manager",
        url: "/portfolio",
    },
    {
        label: "Organisations",
    }
];
